function DurationTitle(){
    return(
        <div>(Caller/Receiver)</div>
    )
}
export default DurationTitle;